exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/shared/modals/modal-confirmation/modal-confirmation.component.css
// module id = ../../../../../src/app/shared/modals/modal-confirmation/modal-confirmation.component.css
// module chunks = main